import { render, staticRenderFns } from "./MultiWithdrawNote.vue?vue&type=template&id=22387391&scoped=true"
import script from "./MultiWithdrawNote.vue?vue&type=script&lang=js"
export * from "./MultiWithdrawNote.vue?vue&type=script&lang=js"
import style0 from "./MultiWithdrawNote.vue?vue&type=style&index=0&id=22387391&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22387391",
  null
  
)

export default component.exports